export default "__VITE_ASSET__492d0d81__"